import Image from "next/image";
import React from "react";

export default function CardImage({ item }) {
  return (
    <figure className="bg-white group hover:bg-gray-600 h-20 md:h-[88px] w-[48px] rounded-[6px] flex justify-center items-center ">
      <Image
        src={process.env.NEXT_PUBLIC_SPACES_URL + item?.icon}
        alt="nurse"
        height={200}
        width={200}
        className="h-7 w-7 object-cover group-hover:brightness-0 group-hover:invert-[1] "
      />
    </figure>
  );
}
